export var TimeToolMutationCodes;
(function (TimeToolMutationCodes) {
    TimeToolMutationCodes["SET_START_DATE"] = "SET_START_DATE";
})(TimeToolMutationCodes || (TimeToolMutationCodes = {}));
export const mutations = {
    [TimeToolMutationCodes.SET_START_DATE](state, payload) {
        state.startDate = payload;
    },
};
